import React, { useContext, useEffect } from "react";
import ReactImageVideoLightboxLib from "react-image-video-lightbox";
import LighboxContext from "../../context/LighboxContext";
import HeaderBarContext from "../../context/HeaderBarContext";

import $ from "jquery";

/* eslint-disable */
function ReactImageVideoLightbox() {
  const { videoUrl, setOpenLightbox } = useContext(LighboxContext);
  const { setOpened } = useContext(HeaderBarContext);
  const windowGlobal = typeof window !== "undefined" && window;

  const jQueryCodeMount = () => {
    if (!windowGlobal) {
      return;
    }
    var width = $(window).width();

    $("#mainGatsbyContainer").children().css("background", "#1B1E29");
    if (width > 500) {
      $("iframe").css("width", "90vw");
      $("iframe").css("height", "90vh");
    } else {
      $("iframe").css("width", "90vw");
      $("iframe").css("height", "250px");
    }
  };

  const jQueryCodeUnmount = () => {
    $("iframe").css("width", "50%");
    $("iframe").css("height", "auto");
  };

  useEffect(() => {
    jQueryCodeMount();
    return () => {
      jQueryCodeUnmount();
    };
  }, []);

  if (!windowGlobal) {
    return <></>;
  }

  return (
    <ReactImageVideoLightboxLib
      data={[
        {
          url: videoUrl,
          type: "video",
          altTag: "some video",
        },
      ]}
      startIndex={0}
      onCloseCallback={() => {
        setOpenLightbox(false);
        setOpened(false);
      }}
    />
  );
}

export default ReactImageVideoLightbox;
